export default __webpack_public_path__ + "static/media/blog-img99.9ba8748a.jpg";